import React from "react";
import styles from "./ImagesAndCTA.module.sass";
import ImageInput from "../../../components/ImageInput";
import collection from "../../../i11/Collection";
import { useUser } from "../../../context";

const ImagesAndCTA = ({ setUploading, setReqBody, reqBody }) => {
	const { locale } = useUser();
	const HandleChange = (e) => {
		setReqBody((p) => {
			return {
				...p,
				image: e,
			};
		});
	};
	return (
		<div className={styles.images}>
			<ImageInput
				where="COLLECTIONS"
				setL={setUploading}
				initial={reqBody.image}
				callBack={HandleChange}
				className={styles.field}
				label={collection[locale].cover}
				tooltip="Maximum 100 characters. No HTML or emoji allowed"
			/>
		</div>
	);
};

export default ImagesAndCTA;
